export enum TeacherFileItemStatus {
  Completed = 'completed',
  Uncompleted = 'uncompleted',
}
